import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';

export default function Hero() {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-slate-50 to-orange-50">
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/d32ac683b276e6264d6b88d11082cec2.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      
      <Navbar />
      
      <div className="relative max-w-7xl mx-auto px-6 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Sol İçerik */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="text-xs font-semibold tracking-widest text-gray-500 uppercase bg-white px-4 py-2 rounded-full shadow-sm">
                2004'ten Beri Etiket Üretiminde Güven ve Kalite
              </span>
            </div>
            
            <h1 className="space-y-2">
              <div className="text-6xl font-bold text-[#1A2332] leading-tight">
                Markanızı
              </div>
              <div className="text-6xl font-bold italic text-[#FF6B35] leading-tight">
                Etiketinizle
              </div>
              <div className="text-6xl font-bold text-[#1A2332] leading-tight">
                Konuşturun
              </div>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
              Ümraniye'den Türkiye'ye; gıdadan kozmetiğe, ilaçtan endüstriyele uzanan geniş sektör yelpazesinde dijital ve flekso baskı teknolojileriyle üretim yapıyoruz. 100 adetten başlayan siparişlerde, 24 saat içinde kargo garantisiyle yanınızdayız.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a 
                href="#contact"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-[#FF6B35] rounded-full hover:bg-[#E55A2B] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Hemen Teklif Alın
                <i className="ri-arrow-right-line ml-2 text-xl"></i>
              </a>
              <a 
                href="#services"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-[#FF6B35] bg-white border-2 border-[#FF6B35] rounded-full hover:bg-[#FF6B35] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Hizmetlerimiz
                <i className="ri-book-open-line ml-2 text-xl"></i>
              </a>
            </div>
            
            {/* İstatistikler */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#FF6B35]">20+</div>
                <div className="text-sm text-gray-600 mt-1">Yıllık Tecrübe</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#FF6B35]">100</div>
                <div className="text-sm text-gray-600 mt-1">Adetten Başlar</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#FF6B35]">24 Saat</div>
                <div className="text-sm text-gray-600 mt-1">Acil Teslimat</div>
              </div>
            </div>
          </div>
          
          {/* Sağ Görsel */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl w-full h-[900px]">
              <img 
                src="https://readdy.ai/api/search-image?query=skilled%20worker%20hands%20carefully%20examining%20freshly%20printed%20adhesive%20product%20labels%20on%20a%20light%20table%20in%20a%20well%20equipped%20print%20shop%20warm%20workshop%20lighting%20showing%20quality%20control%20inspection%20of%20colorful%20label%20sheets%20with%20crisp%20detail%20and%20professional%20craftsmanship&width=800&height=900&seq=hero-main-v2-102&orientation=portrait"
                alt="Bioetiket kalite kontrol - Profesyonel etiket üretimi Ümraniye İstanbul"
                className="w-full h-full object-cover"
                width="800"
                height="900"
                fetchpriority="high"
                loading="eager"
                decoding="async"
              />
              
              {/* Floating Cards */}
              <div className="absolute top-8 left-8 bg-white rounded-2xl shadow-xl p-4 animate-float">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-checkbox-circle-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-800">Kalite Garantisi</div>
                    <div className="text-xs text-gray-500">ISO Sertifikalı</div>
                  </div>
                </div>
              </div>
              
              <div className="absolute bottom-8 right-8 bg-[#FF6B35] rounded-2xl shadow-xl p-4 animate-float-delayed">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-rocket-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-white">Hızlı Üretim</div>
                    <div className="text-xs text-white/80">Aynı Gün Kargo</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}